import React from 'react';
import './FeaturedReviews.scss';
import Slider from 'react-slick';
import { renderSlides } from './util/renderSlides';
import Button from '../@redantler/redantler-npm-button-react';
import { COLORS } from '../../constants/colors';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import PrevArrowButton from '../UI/Icons/PrevArrowButton';
import NextArrowButton from '../UI/Icons/NextArrowButton';

/**
 * Renders featured reviews slider
 * @param {string} title
 * @param {array} slides
 * @param {string} starsAssetUrl
 * @param {boolean} showCta
 * @param {string} ctaText
 * @param {string} ctaLink
 * @returns {JSX.Element}
 * @constructor
 */
const FeaturedReviews = ({ title, slides, starsAssetUrl, showCta = false, ctaText, ctaLink }) => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <Button addClass="c-featured-reviews__arrow c-featured-reviews__prev">
        <PrevArrowButton color={COLORS.white} />
      </Button>
    ),
    nextArrow: (
      <Button addClass="c-featured-reviews__arrow c-featured-reviews__next">
        <NextArrowButton color={COLORS.white} />
      </Button>
    ),
  };

  return (
    <div className="c-featured-reviews module-background-color-green">
      <div className="c-featured-reviews__inner">
        <div className="c-featured-reviews__text">
          <div className="c-featured-reviews__title h2-roobert color-gray">
            <h2>{title}</h2>
          </div>
          {showCta && (
            <div className="c-featured-reviews__cta">
              <CTAButton
                type={'secondary'}
                link={ctaLink}
                text={ctaText}
                target={'_self'}
                additionalClasses={'cta color-white'}
              />
            </div>
          )}
        </div>
        <div className="c-featured-reviews__slides">
          <Slider {...settings}>{renderSlides(starsAssetUrl, slides)}</Slider>
        </div>
      </div>
    </div>
  );
};

export default FeaturedReviews;
